import { trackInteraction } from 'client/javascript/analytics';
import { sendBucketEvent } from 'client/javascript/heap';

const PRICE_SELECTOR = '.product-card__action';
const PRODUCT_CARD_SELECTOR = '.product-card ';

const priceHandlerClick = ({ target }) => {
  const card = target.closest(PRODUCT_CARD_SELECTOR);
  trackInteraction({
    label: 'Building Page Click Reservable Starting Price',
    amount: card.dataset.amount,
    currency: card.dataset.currency,
    reservable_type: card.dataset.reservable_type
  });
};

export const setupBuildingsAnalytics = () => {
  const cards = document.querySelectorAll(PRICE_SELECTOR);
  cards.forEach(priceElement => priceElement.addEventListener('click', priceHandlerClick));
};

export function setupBuildingPagePDPExperiment() {
  const AllAccessSelector = document.querySelector('div.product-cards-block a.product-card');

  if (!AllAccessSelector) {
    return;
  }

  sendBucketEvent('buildingPagePDP', { customLabel: 'building page PDP before checkout' });

  AllAccessSelector.addEventListener('click', () => {
    trackInteraction({
      label: 'Click - All Access Signup Link'
    });
  });
}
